import React, {useRef, useState} from 'react';
import {Pressable, View} from 'react-native';
import OTPTextInput from 'react-native-otp-textinput';
import OtpInput from 'react-otp-input';
import {ThemeProvider, useTheme} from '@rneui/themed';
import {ErrorMessage as FormikErrorMessage, Formik} from 'formik';
import {observer} from 'mobx-react-lite';
import * as Yup from 'yup';

import RewardsProgramImage from '../../components/rewards/ProgramImage';
import Button from '../../components/themed/Button';
import KeyboardAwareScrollView from '../../components/themed/KeyboardAwareScrollView';
import Text from '../../components/themed/Text';
import TextInput from '../../components/themed/TextInput';
import Otp from '../../components/ui-controls/form/Otp';
import ValidationMessage from '../../components/ui-controls/form/ValidationMessage';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {fontFamilyStyle} from '../../components/ui-controls/Text';
// import CheckboxComponent from '../../components/ui-controls/web/CheckBox';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {navigate} from '../../navigation/RootNavigation';
import {useStores} from '../../stores/use-stores';
import rewardsTheme from '../../theme/rewardsTheme';
import apiService from '../../transport/apiService';
import {Analytics} from '../../utils/analytics/analytics';
import {
  EventName,
  EventScreenName,
  EventSourceType,
} from '../../utils/analytics/events';
import {testDeepLink} from '../../utils/onesignal';
import {SignInSchema} from '../rewards/validationSchema';
const KitchenSinkScreen = observer(
  ({route}: RouteNavigatorScreenProps<AppRoute.KITCHENSINK_INDEX>) => {
    const [isSubmitting, setSubmitting] = useState(false);

    const onSubmit = async (values: SignInValues) => {
      setSubmitting(true);
      try {
        const result = await apiService.rewardsCheckAccountExists(values);
        if (result?.status === 200) {
          if (result.data?.exists) {
            navigate(AppRoute.REWARDS_VERIFICATION);
          } else {
            navigate(AppRoute.REWARDS_SIGN_UP);
          }
        }
      } catch (e) {}
      setSubmitting(false);
    };

    const validationSchema = SignInSchema;

    type SignInValues = Yup.InferType<typeof validationSchema>;

    const defaultValues: SignInValues = {
      phoneNumber: '',
    };

    return (
      <ThemeProvider theme={rewardsTheme}>
        <KeyboardAwareScrollView keyboardShouldPersistTaps="always">
          <Formik
            initialValues={defaultValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}>
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              initialValues,
              setFieldValue,
              setFieldError,
              setFieldTouched,
              touched,
              values,
            }) => {
              return (
                <ContentView>
                  <RewardsProgramImage variant="onLight" />

                  <Text variant="heading0">Typography</Text>
                  <Text variant="heading0">heading0</Text>
                  <Text variant="heading1">heading1</Text>
                  <Text variant="heading2">heading2</Text>
                  <Text variant="heading3">heading3</Text>
                  <Text variant="heading4">heading4</Text>
                  <Text variant="body">body</Text>
                  <Text variant="body2">body2</Text>
                  <Text variant="caption">caption</Text>

                  <Text variant="heading0">Text Input</Text>

                  <View style={{flexDirection: 'row', gap: 8}}>
                    <View style={{flexGrow: 1}}>
                      <TextInput
                        accessibilityLabel="Your mobile number:"
                        autoCapitalize="none"
                        autoComplete="tel"
                        errorMessageWhenTouched={errors.phoneNumber}
                        keyboardType="phone-pad"
                        label="Your mobile number:"
                        maxLength={20}
                        onBlur={handleBlur('phoneNumber')}
                        onChangeText={handleChange('phoneNumber')}
                        touched={touched.phoneNumber}
                      />
                    </View>
                    <View style={{flexGrow: 1}}>
                      <TextInput
                        accessibilityLabel="Your mobile number:"
                        autoCapitalize="none"
                        autoComplete="tel"
                        errorMessageWhenTouched={errors.phoneNumber}
                        keyboardType="phone-pad"
                        label="Your mobile number:"
                        maxLength={20}
                        onBlur={handleBlur('phoneNumber')}
                        onChangeText={handleChange('phoneNumber')}
                        touched={touched.phoneNumber}
                      />
                    </View>
                  </View>
                  <View style={{}}>
                    <Otp
                      numInputs={6}
                      onChangeText={handleChange('phoneNumber')}
                    />
                    {/* <OtpInput
                      containerStyle={{width: '100%', gap: 8}}
                      value={values.phoneNumber}
                      onChange={handleChange('phoneNumber')}
                      onPaste={event => {
                        handleChange('phoneNumber')(
                          event.clipboardData.getData('text'),
                        );
                      }}
                      numInputs={6}
                      renderSeparator={null}
                      renderInput={props => (
                        <View style={{flexGrow: 1}}>
                          <TextInput {...props} />
                        </View>
                      )}
                    /> */}
                  </View>

                  <View style={{gap: 8}}>
                    <Button
                      title={'Continue'}
                      onPress={() => handleSubmit()}
                      disabled={isSubmitting}
                      loading={isSubmitting}
                    />
                    <Button
                      title={'Go Back'}
                      onPress={() => handleSubmit()}
                      disabled={isSubmitting}
                      loading={isSubmitting}
                      secondary
                    />
                  </View>
                </ContentView>
              );
            }}
          </Formik>
          <Colors />
        </KeyboardAwareScrollView>
      </ThemeProvider>
    );
  },
);

function Colors() {
  const {theme} = useTheme();
  const colors = [
    'grey0',
    'grey1',
    'grey2',
    'grey3',
    'grey4',
    'grey5',
    'greyOutline',
  ];
  const customcolors = [
    '#ffffff', // white
    '#5B5B5B', // grey6
    '#7E7E7E', // grey5
    '#A4A4A4', // grey4
    '#ffffff', // white
    // 'rgba(0,0,0,0.12)', //grey3
    '#F3F3F3', // grey2
  ];
  return (
    <>
      <View style={{flexDirection: 'row'}}>
        {colors.map(color => {
          return (
            <View
              key={color}
              style={{
                width: 40,
                height: 40,
                backgroundColor: theme.colors[color],
              }}
            />
          );
        })}
      </View>
      <View style={{flexDirection: 'row'}}>
        {customcolors.map((color, i) => {
          return (
            <View
              key={i}
              style={{
                width: 40,
                height: 40,
                backgroundColor: color,
              }}
            />
          );
        })}
      </View>
    </>
  );
}

export default KitchenSinkScreen;
